import { ExpoferiaComponent } from './../expoferia/expoferia.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ListaCentrosComercialesComponent } from '../lista-centros-comerciales/lista-centros-comerciales.component';

@Component({
  selector: 'app-evento-feria',
  templateUrl: './evento-feria.component.html',
  styleUrls: ['./evento-feria.component.scss'],
})
export class EventoFeriaComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public dialogRefEvento: MatDialogRef<EventoFeriaComponent>
  ) {}

  ngOnInit(): void {}

  openExpoferiaModal() {
    const dialogRef = this.dialog.open(ExpoferiaComponent, {
      width: '700px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
    this.dialogRefEvento.close();
  }
  onCancel(): void {
    this.dialogRefEvento.close();
  }

  openListMallModal() {
    const dialogRef = this.dialog.open(ListaCentrosComercialesComponent, {
      width: '700px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
    this.dialogRefEvento.close();
  }
}
